import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputModule } from '../../../angular-core/components/input/input.module';
import { HasPermissionPipeModule } from '../../../shared/pipes/has-permission/has-permission.module';
import { TranslateModule } from '@ngx-translate/core';
import { XPACManagementRoutingModule } from './xpac-management-routing.module';
import { DialogHeaderModule } from 'src/app/angular-core/components/dialog-header/dialog-header.module';
import { ListItemModule } from 'src/app/angular-core/components/list-item/list-item.module';
import { SearchBarModule } from 'src/app/angular-core/components/search-bar/search-bar.module';
import { FilterPipeModule } from 'src/app/angular-core/utils/pipes/filter/filter.pipe.module';
import { LocalizedDateModule } from 'src/app/angular-core/utils/pipes/localized-date/localized-date.pipe.module';
import { XpacInfoComponent } from './xpac-info/xpac-info.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { XpacLicenseComponent } from './xpac-license/xpac-license.component';
import { XpacOrdersComponent } from './xpac-orders/xpac-orders.component';
import { StoreInfoComponent } from './store-info/store-info.component';
import { XpacDetailsComponent } from './xpac-details/xpac-details.component';
import { XpacLoggingComponent } from './xpac-logging/xpac-logging.component';
import { XpacLoggingDetailsComponent } from './xpac-logging/xpac-logging-details/xpac-logging-details.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { XpacTelemetryComponent } from './xpac-telemetry/xpac-telemetry.component';
import { XpacDevicesComponent } from './xpac-devices/xpac-devices.component';
import { AddressSearchModule } from 'src/app/shared/components/address-search/address-search.module';

@NgModule({
  declarations: [
    XpacInfoComponent,
    XpacLicenseComponent,
    XpacOrdersComponent,
    StoreInfoComponent,
    XpacDetailsComponent,
    XpacLoggingComponent,
    XpacLoggingDetailsComponent,
    XpacTelemetryComponent,
    XpacDevicesComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatCardModule,
    MatSlideToggleModule,
    HasPermissionPipeModule,
    MatAutocompleteModule,
    InputModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatTabsModule,
    SearchBarModule,
    DialogHeaderModule,
    FilterPipeModule,
    ListItemModule,
    LocalizedDateModule,
    MatProgressSpinnerModule,
    XPACManagementRoutingModule,
    MatListModule,
    MatBadgeModule,
    MatCheckboxModule,
    AddressSearchModule,
  ],
  exports: [
    StoreInfoComponent,
  ]
})
export class XPACManagementModule { }
